import { Helmet } from "react-helmet";
import Canonical from "../../../../components/common/layout/Canonical";
import { useTranslation } from "react-i18next";
import CorporateHeader from "../../../../components/common/layout/CorporateHeader";
import { useSitemap } from "../../../../shared/hooks/use-sitemap";
import PropertyList from "../../../../components/corporate/corporate/properties/PropertyList";
import { useSelector } from "react-redux";

const Properties = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const { t } = useTranslation('common');
    useSitemap();

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.properties.title")}</title>
                <meta name="description" content={t("seo_friendly.properties.desc")} />
            </Helmet>

            <div className="dark:bg-bgDarkDull bg-white w-full h-full">
                <div className="w-full properties-bg relative h-full">
                    <img src={require('../../../../assets/images/pattern5.png')} alt="pattern" className="absolute left-0 bottom-0 dark:opacity-[0.2] flex items-start justify-start h-full" />
                    <img src={require('../../../../assets/images/property-bg.png')} alt="pattern" className="absolute bottom-0 left-0 right-0 w-full min-h-[177px] object-cover" />
                    <div className="relative z-[2]">
                        <CorporateHeader />
                    </div>

                    <div className="container w-full h-full flex items-center justify-center py-[40px] sm:py-[50px] xlx:py-[70px] 3xl:py-[85px] relative z-[1]">
                        <h2 className="text-primaryText dark:text-white font-bold max-w-[550px] xlx:max-w-[624px] text-center">{lang === 'en' ? <>Explore Premium Commercial Spaces Across <span className="text-primary">Mumbai Metro Line 3</span></> : lang === 'hi' ? <><span className="text-primary">मुंबई मेट्रो लाइन 3</span> में प्रीमियम व्यावसायिक स्थानों का अन्वेषण करें</> : <><span className="text-primary">मुंबई मेट्रो लाइन 3</span> मधील प्रीमियम व्यावसायिक जागा एक्सप्लोर करा</>}</h2>
                    </div>
                </div>

                <div id="home" className="pb-[30px] lg:pb-[50px] w-full">
                    <PropertyList />
                </div>
            </div>
        </>
    );
};

export default Properties;